// src/utils/cookieConsent.ts
import ReactGA from "react-ga4";

const CONSENT_COOKIE_NAME = 'cookie_consent';

export const initCookieConsent = () => {
  const GA_ID = import.meta.env.VITE_GA_ID;
  
  // Si pas de GA_ID configuré, ne rien faire
  if (!GA_ID) return;
  
  // Vérifier si l'utilisateur a déjà donné son consentement
  const consent = getCookieConsent();
  
  if (consent === 'accepted') {
    // Initialiser GA si consentement accepté
    ReactGA.initialize(GA_ID);
  }
  // Si consent === 'declined' ou null, ne rien faire (la bannière s'affichera)
};

// Obtenir le consentement stocké
export const getCookieConsent = (): 'accepted' | 'declined' | null => {
  if (typeof localStorage === 'undefined') return null;
  const value = localStorage.getItem(CONSENT_COOKIE_NAME);
  if (value === 'accepted' || value === 'declined') {
    return value;
  }
  return null;
};

// Enregistrer le consentement
export const setCookieConsent = (consent: 'accepted' | 'declined') => {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(CONSENT_COOKIE_NAME, consent);
  
  // Si accepté, initialiser GA
  if (consent === 'accepted') {
    const GA_ID = import.meta.env.VITE_GA_ID;
    if (GA_ID) {
      ReactGA.initialize(GA_ID);
    }
  }
};

// Fonction pour vérifier si l'utilisateur a consenti
export const hasAnalyticsConsent = (): boolean => {
  return getCookieConsent() === 'accepted';
};

// Fonction pour tracker uniquement si consentement
export const trackPageView = (path: string, title?: string) => {
  if (hasAnalyticsConsent()) {
    ReactGA.send({ hitType: "pageview", page: path, title });
  }
};
